export function removeExtraSpace(str: string) {
    return str.replace(/\s+/g, " ").trim();
}
